import VesselTrackingWrapper from "./components/VesselTrackingWrapper"

const routes = [
    {
        path: "vesseltracking",
        permissionForPage: "read:vesseltracking",
        component: VesselTrackingWrapper
    },
]

const settings = {
    routes,
}

export default settings